/// <reference path="../../../node_modules/react-datetime/react-datetime.d.ts" />

import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import {
    Modal,
    Button,
    ButtonGroup,
    FormGroup,
    FormControl,
    ControlLabel,
    Row,
    Col,
    Table,
    Checkbox
} from 'react-bootstrap';
import { handleError } from '../../shared/ErrorCatching';
import * as actions from './InvoiceActions';
import { assign } from '../../shared/Assign';
import DateTime from 'react-datetime';

class CreditInvoiceModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            invoiceId: props.invoiceId,
            invoiceDate: props.invoiceDate,
            message: null,
            rows: [],
            creating: false,
            created: false
        };

        this.onDateTimeChange = this.onDateTimeChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.update = this.update.bind(this);
        this.create = this.create.bind(this);
        this.print = this.print.bind(this);
    }

    componentDidMount(): void {
        this.update();
    }

    UNSAFE_componentWillReceiveProps(nextProps: any): void {
        if (nextProps.newCreditInvoice) {
            this.setState({
                rows: assign([], nextProps.newCreditInvoice.rows)
            });
        }
    }

    update(): void {
        this.props.actions
            .new(this.state.invoiceId, this.state.invoiceDate, this.state.message, this.state.rows)
            .catch((error: any) => handleError(error));
    }

    create(): void {
        this.setState({ creating: true });

        this.props.actions
            .create(
                this.state.invoiceId,
                this.state.invoiceDate,
                this.state.message,
                this.state.rows
            )
            .then(() => {
                this.props.onCreate();
                this.setState({ created: true });
            })
            .catch((error: any) => handleError(error))
            .then(() => {
                this.setState({ creating: false });
            });
    }

    print(): void {
        window.print();
    }

    onDateTimeChange(moment: any): void {
        let newState = assign({}, this.state);
        newState.invoiceDate = moment ? moment.toDate() : null;
        this.setState(newState);
    }

    onMessageChange(e: any): void {
        let newState = assign({}, this.state);
        newState.message = e.target.value;
        this.setState(newState);
    }

    onCommentChange(index: number, e: any) {
        let newState = assign({}, this.state);
        newState.rows[index].comment = e.target.value;
        this.setState(newState);
    }

    onQuantityChange(index: number, e: any) {
        let newState = assign({}, this.state);
        newState.rows[index].quantity = e.target.value;
        this.setState(newState);
    }

    onShouldCreditChange(index: number, e: any) {
        let newState = assign({}, this.state);
        newState.rows[index].shouldCredit = e.target.checked;
        this.setState(newState);
    }

    onAmountChange(index: number, e: any) {
        let newState = assign({}, this.state);
        newState.rows[index].amount = e.target.value;
        this.setState(newState);
    }

    render() {
        return (
            <div>
                <Modal show={true} onHide={this.props.closeModal} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('credit-invoice/new/title')}{' '}
                            {this.props.newCreditInvoice.invoiceToCreditNumber}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={9} className="invoice-preview-column">
                                {this.props.newCreditInvoice &&
                                    this.props.newCreditInvoice.renderedTemplate && (
                                        <div
                                            id="invoice-preview"
                                            dangerouslySetInnerHTML={{
                                                __html: this.props.newCreditInvoice.renderedTemplate
                                            }}
                                        ></div>
                                    )}
                            </Col>
                            {!this.state.created && (
                                <Col xs={12} lg={3} className="hide-print invoice-modifier-column">
                                    <FormGroup>
                                        <ControlLabel>
                                            {Translate('invoice/new/form/input-label/invoice-date')}
                                        </ControlLabel>
                                        <DateTime
                                            value={this.state.invoiceDate}
                                            dateFormat="YYYY-MM-DD"
                                            timeFormat={false}
                                            onChange={this.onDateTimeChange}
                                            closeOnSelect={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>
                                            {Translate('invoice/new/form/input-label/message')}
                                        </ControlLabel>
                                        <FormControl
                                            autoFocus
                                            componentClass="textarea"
                                            name="message"
                                            className="text-area-roomy"
                                            value={this.state.message ? this.state.message : ''}
                                            onChange={this.onMessageChange}
                                        />
                                    </FormGroup>

                                    <h3>{Translate('credit-invoice/header/credit')}</h3>
                                    {this.state.rows &&
                                        this.state.rows.map((x, i) => (
                                            <div key={i}>
                                                <FormGroup>
                                                    <Checkbox
                                                        name="shouldCredit"
                                                        checked={x.shouldCredit}
                                                        onChange={(e) =>
                                                            this.onShouldCreditChange(i, e)
                                                        }
                                                    >
                                                        <span>{x.productName} <i>({x.orderCollectionNumberWithOrderNumber})</i> </span>
                                                    </Checkbox>
                                                </FormGroup>
                                                {x.shouldCredit && (
                                                    <Row className="crediting-item-info">
                                                        <Col sm={6}>
                                                            <FormGroup>
                                                                <ControlLabel>
                                                                    {Translate(
                                                                        'credit-invoice/header/quantity'
                                                                    )}
                                                                </ControlLabel>
                                                                <FormControl
                                                                    type="text"
                                                                    name="message"
                                                                    value={x.quantity}
                                                                    onChange={(e) =>
                                                                        this.onQuantityChange(i, e)
                                                                    }
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <FormGroup>
                                                                <ControlLabel>
                                                                    {Translate(
                                                                        'credit-invoice/header/sum'
                                                                    )}
                                                                </ControlLabel>
                                                                <FormControl
                                                                    type="text"
                                                                    name="amount"
                                                                    value={x.amount}
                                                                    onChange={(e) =>
                                                                        this.onAmountChange(i, e)
                                                                    }
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={12}>
                                                            <FormGroup>
                                                                <ControlLabel>
                                                                    {Translate(
                                                                        'credit-invoice/header/comment'
                                                                    )}
                                                                </ControlLabel>
                                                                <FormControl
                                                                    type="text"
                                                                    name="message"
                                                                    value={
                                                                        x.comment ? x.comment : ''
                                                                    }
                                                                    onChange={(e) =>
                                                                        this.onCommentChange(i, e)
                                                                    }
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </div>
                                        ))}

                                    {!this.state.creating && (
                                        <ButtonGroup>
                                            <Button
                                                onClick={this.props.closeModal}
                                                bsStyle="default"
                                            >
                                                {Translate('credit-invoice/close')}
                                            </Button>
                                            {!this.state.created && (
                                                <Button
                                                    onClick={() => this.update()}
                                                    bsStyle="default"
                                                >
                                                    {Translate('credit-invoice/update')}
                                                </Button>
                                            )}
                                            <Button onClick={() => this.print()} bsStyle="primary">
                                                {Translate('credit-invoice/print')}
                                            </Button>
                                            {!this.state.created && (
                                                <Button
                                                    onClick={() => this.create()}
                                                    bsStyle="primary"
                                                >
                                                    {this.props.newCreditInvoice.invoiceOnEmail
                                                        ? Translate('credit-invoice/save-and-send')
                                                        : Translate('credit-invoice/save')}
                                                </Button>
                                            )}
                                        </ButtonGroup>
                                    )}
                                    {this.state.creating && <i className="load-spin-dark"></i>}
                                </Col>
                            )}
                        </Row>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        newCreditInvoice: state.invoices.newCreditInvoice
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: (invoiceId: number, invoiceDate: any, message: string, rows: any[]) =>
                dispatch(actions.getNewCreditInvoice(invoiceId, invoiceDate, message, rows)),
            create: (invoiceId: number, invoiceDate: any, message: string, rows: any[]) =>
                dispatch(actions.createCreditInvoice(invoiceId, invoiceDate, message, rows))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditInvoiceModal);
